import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from '@material-ui/core';
import { ExpandMore, Add } from '@material-ui/icons';
import { useStyles } from './styles';
import { generateId } from '../../pages/AddEngineering/utils';
import VictimForm from './VictimForm';
import { VehicleObject, VictimObject } from '../../@types/incidentTypes';

const initialVictim: VictimObject = {
  index: 0,
  'Usava Cinto ou Capacete': 'Não informado',
  'Perfil do Usuário': 'Não informado',
  'Data de Alta': '',
  Nome: '',
  'Categoria do Condutor': 'Não informado',
  'Tipo de Morte': '',
  'Início de Reabilitação': '',
  Encaminhamento: 'Não informado',
  'Tipo de Pessoa': 'Não informado',
  'Posição do passageiro': 'Não informado',
  'Data de Nascimento': '',
  'Data do Óbito': '',
  Observações: '',
  'Procedimentos realizados': '',
  Sexo: 'Não informado',
  Idade: -1,
  'Situação do Condutor': 'Não informado',
  'Tipo Documento': 'Não informado',
  'Número do cartão de saúde cidadão': '',
  Dosagem: '',
  'Código Veículo': 'Nenhum',
  'Evolução de caso': 'Não informado',
  'Número Documento': '',
  'Data de Internação': '',
  'Número da CNH': '',
  'Exame de alcoolemia': 'Não informado',
  'Gravidade da Lesão': 'Não informado',
  Lesões: [],
  'Fim da Reabilitação': '',
  'Custo Geral': '',
  _localId: '',
};

interface IProps {
  driverVictims: VictimObject[];
  setDriverVictims: React.Dispatch<React.SetStateAction<VictimObject[]>>;
  vehicles: VehicleObject[];
  requiredFields: { key: string; message: string }[];
  desabilitado?: boolean;
}

const VictimFormGroup: React.FC<IProps> = ({
  driverVictims,
  setDriverVictims,
  vehicles,
  requiredFields,
  desabilitado,
}) => {
  const classes = useStyles();

  const addNewVictims = () => {
    const list = driverVictims;
    list.push({ ...initialVictim, index: driverVictims.length, _localId: generateId() });
    setDriverVictims([...list]);
  };

  const deleteVictims = (index: number) => {
    const list = driverVictims
      .filter((item) => {
        return item.index !== index;
      })
      .map((item, i) => {
        return { ...item, index: i };
      });
    setDriverVictims([...list]);
  };

  const changeVitimsState = (via: VictimObject) => {
    const list = [...driverVictims];
    list[via.index] = via;
    setDriverVictims(list);
  };

  return (
    <Accordion className={classes.accordionContainer}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Vítimas</Typography>{' '}
      </AccordionSummary>
      <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <div className={classes.addButtonContainer}>
            <Button
              color="default"
              variant="outlined"
              endIcon={<Add />}
              className={classes.addButton}
              onClick={() => addNewVictims()}
              disabled={desabilitado}
            >
              Adicionar
            </Button>
          </div>

          {driverVictims.map((item, index) => {
            item.index = index;
            return (
              <VictimForm
                key={item._localId}
                victimObject={item}
                deleteVictim={deleteVictims}
                changeVictimsState={changeVitimsState}
                vehicles={vehicles}
                requiredFields={requiredFields}
                desabilitadoVictmForm={desabilitado}
              />
            );
          })}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default VictimFormGroup;
